import React, { useEffect, useMemo, Fragment } from 'react';
import { object } from 'prop-types';
import classNames from 'classnames/bind';
import qs from 'qs';

import { DealerLocator } from 'components/DealerLocator';
import Breadcrumbs from 'components/Breadcrumbs';
import Container from 'components/Container';
import TopProductControls from './components/TopProductControls';
import MainInfo from './components/MainInfo';
import ManufacturesInfo from './components/ManufacturesInfo';

import ProductTabsContainer from './containers/ProductTabsContainer';

import { gtmPushEvent } from 'utils/gtmPushEvent';
import { isGlobalSite } from 'utils/currentLanguage';

import styles from './Product.module.scss';
const cx = classNames.bind(styles);

const Product = ({ data, match, searchHistory, action }) => {
  const articleAddName = data.product.assignedArticle.articleAddName;
  const pageTitle = data.product
    ? `${data.product.assignedArticle.articleName} ${
        articleAddName ? articleAddName : ''
      }`
    : '';

  const breadcrumbs = useMemo(() => {
    const { search: searchValue, country } = qs.parse(searchHistory, {
      ignoreQueryPrefix: true,
    });
    const countryValue = country && isGlobalSite ? '?country=' + country : '';

    return searchHistory && searchHistory.length && action !== 'POP' ? {
      techassist: {
        id: 1,
        active: false,
        url: '/',
      },
      searchResults: {
        id: 2,
        url: `/search${countryValue}#${searchValue}`,
        active: false,
      },
      productDetails: {
        id: 3,
        active: true,
      },
    } : {
      techassist: {
        id: 1,
        active: false,
        url: '/',
      },
      productDetails: {
        id: 3,
        active: true,
      },
    };
  }, []);

  useEffect(() => {
    if (data.product) {
      const pushTechDocument = {
        event: 'technicalDocumentation',
        productName: data.product.assignedArticle.articleName,
        productReference: data.product.assignedArticle.articleNo,
        productStatus: data.product.assignedArticle.articleStateName,
      };

      gtmPushEvent(pushTechDocument);
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [match.params.articleId]);

  return (
    <Fragment>
      <div className={cx('product-wrapper')}>
        <Container>
          <Breadcrumbs data={breadcrumbs} />
          <TopProductControls pageTitle={pageTitle} searchHistory={searchHistory} action={action} />
          {data.product && (
            <Fragment>
              <MainInfo data={data} />
              <ProductTabsContainer
                articleNo={data.product.assignedArticle.articleNo}
                data={data}
                match={match}
              />
            </Fragment>
          )}
          <div className={cx('delaer-locator-mobile')}>
            <DealerLocator />
          </div>
        </Container>
      </div>
      {data.product && (
        <div className={cx('manufacture-wrapper')}>
          <Container>
            <ManufacturesInfo
              brandId={data.product.assignedArticle.brandNo.toString()}
            />
          </Container>
        </div>
      )}
    </Fragment>
  );
};

Product.propTypes = {
  data: object.isRequired,
};

export default Product;



// WEBPACK FOOTER //
// ./src/pages/Product/Product.js